import React from 'react'
import PageHeader from '../../components/pageHeader/PageHeader'

const About = () => {
  return (
    <div>
       <PageHeader title={'About us'}/>
       <h1>About us</h1>
    </div>
  )
}

export default About